import type { World, WorldCategory, WorldManifestEntry, WorldsManifest } from '../types/world';

export interface CatalogWorld {
  info: WorldManifestEntry;
  world: World;
}

// Categories describe navigation only: IDs, availability and saved progress stay with the world.
export function getCategoryWorlds(category: WorldCategory, worlds: CatalogWorld[]): CatalogWorld[] {
  const available = new Map(worlds.filter(({ info }) => info.enabled).map(item => [item.world.id, item]));
  return category.worlds.flatMap(id => {
    const item = available.get(id);
    return item ? [item] : [];
  });
}

export function getVisibleCategories(manifest: WorldsManifest, worlds: CatalogWorld[]) {
  return (manifest.categories ?? []).map(category => ({ category, worlds: getCategoryWorlds(category, worlds) }))
    .filter(item => item.worlds.length > 0);
}

export function getUncategorizedWorlds(manifest: WorldsManifest, worlds: CatalogWorld[]): CatalogWorld[] {
  const assigned = new Set((manifest.categories ?? []).flatMap(category => category.worlds));
  return worlds.filter(({ info, world }) => info.enabled && !assigned.has(world.id));
}

export function findWorldCategory(manifest: WorldsManifest, worldId: string): WorldCategory | undefined {
  return manifest.categories?.find(category => category.worlds.includes(worldId));
}
